module.exports = __webpack_public_path__ + "static/Shreyas_Kamath-6b70775a53f5081c89bcf12bd4096e1f.jpeg";